import { BranchOptions } from "../../../constants/constants";
import { RenderColumn } from "../../../types/column.types";
import { ICourse } from "../../../types/course.types";

export const BranchNameColumn: RenderColumn<ICourse> = (_, course) => {
    return course.branch ? BranchOptions[course.branch]['label'] : 'n/a';
};